// C-S4: ActivityForm works a status out from the When (Task / Upcoming / Overdue). For a saved
// record that only applies while its status is one of those three; any other status (Rescheduled,
// Completed, Cancelled, or one picked from the header menu in this visit) is the user's and stays.
export const DATE_DRIVEN_STATUSES = ['Upcoming', 'Overdue', 'Task']

// record: the form's activity (a copy of the saved one, plus any header-menu change)
export function savedStatusToKeep(record, statuses) {
  const saved = record && record.activityId && record.activityStatus
  if (!(saved && saved.statusName) || DATE_DRIVEN_STATUSES.includes(saved.statusName)) return null
  const listed = (statuses || []).find(s => s && (saved.id ? s.id === saved.id : s.statusName === saved.statusName))
  return listed || saved
}
